var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVoucherCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#1C2154"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeWidth: 2.5,
    d: "M1.25 19.743c1.898-.584 3.08-1.204 3.927-2.169C5.996 16.643 6.5 15.386 6.5 14c0-1.365-.49-2.605-1.28-3.531-.828-.972-1.984-1.6-3.27-1.704h0L1.25 3.5c0-.621.252-1.184.659-1.591.407-.407.97-.659 1.591-.659h35c.621 0 1.184.252 1.591.659.407.407.659.97.659 1.591h0v4.925c-1.669.344-2.904.932-3.796 1.868-.901.946-1.454 2.255-1.454 3.707 0 1.38.5 2.632 1.306 3.562.844.974 2.02 1.596 3.324 1.679h0l.62 5.259c0 .621-.252 1.184-.659 1.591-.407.407-.97.659-1.591.659h0-35c-.621 0-1.184-.252-1.591-.659-.407-.407-.659-.97-.659-1.591h0z",
    transform: "translate(-339 -264) translate(264 234) translate(75 30) translate(1.891 3.5) translate(.109)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M13 26.374L13 22M13 7L13 2M13 17L13 11",
    transform: "translate(-339 -264) translate(264 234) translate(75 30) translate(1.891 3.5) translate(.109)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    strokeWidth: 2,
    d: "M29.698 12.419l-3.377-.517-1.512-3.216c-.118-.248-.507-.248-.625 0l-1.512 3.216-3.377.517c-.132.022-.236.116-.278.247-.041.131-.007.277.09.372l2.449 2.503-.576 3.53c-.02.138.028.276.139.356.104.08.25.095.367.03l3.01-1.667 3.025 1.666c.048.03.104.044.159.044.07 0 .146-.022.201-.073.104-.08.16-.218.139-.356l-.576-3.53 2.449-2.503c.097-.095.131-.24.09-.372-.049-.13-.153-.232-.285-.247z",
    transform: "translate(-339 -264) translate(264 234) translate(75 30) translate(1.891 3.5) translate(.109)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C2154",
    fillRule: "nonzero",
    d: "M32.185 31c.69 0 1.25.56 1.25 1.25 0 .647-.492 1.18-1.122 1.244l-.128.006H1.25C.56 33.5 0 32.94 0 32.25c0-.647.492-1.18 1.122-1.244L1.25 31h30.935zM39.134 36.5c.69 0 1.25.56 1.25 1.25 0 .647-.492 1.18-1.122 1.244l-.128.006H1.25C.56 39 0 38.44 0 37.75c0-.647.492-1.18 1.122-1.244l.128-.006h37.884z",
    transform: "translate(-339 -264) translate(264 234) translate(75 30) translate(1.891 3.5)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoucherCode);
export default __webpack_public_path__ + "static/media/icon-voucher-code.5883051d.svg";
export { ForwardRef as ReactComponent };